<template lang="pug">
ods-form.twoFactorAuth-form(
  :model='twoFactorAuthForm',
  :rules='rules',
  ref='twoFactorAuthForm'
  :hide-required-asterisk="true")
  div
    div(align='center')
        img(:src='getImgUrl()')
    h1.twoFactorAuth-form__title {{ $t('login.twoFactorAuth') }}
    .twoFactorAuth-form__errors(v-show="errors")
      ods-alert(
        :title="errorInfo || $t('login.error.invalid_code')",
        type='error',
        :closable='false')
    ods-form-item(:label="$t('login.codeLabel')" prop='code' class="ods-mb-10")
      ods-input(
        :class="{error: errors}"
        type="text"
        v-model.trim="twoFactorAuthForm.code"
        maxlength="5")
  div
  div.twoFactorAuth-form__actions
    ods-button.ods-button__btnRcovery(type='primary', native-type='submit', @click.prevent="submitForm('twoFactorAuthForm')") {{ $t('buttons.btnSend') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'

export default {
  name: 'twoFactorAuth-form-generic',
  props: {
    css: {
      type: String
    },
    logo: {
      type: String
    },
    next: {
      type: String
    },
    localproject: {
      type: String
    },
    logomenu: {
      typlogomenue: String
    }
  },

  data () {
    return {
      twoFactorAuthForm: {
        code: ''
      },
      rules: {
        code: [
          { required: true, message: this.$t('login.rules.code.required'), trigger: 'submit' },
          { pattern: /^[a-zA-Z0-9]{5}$/, message: this.$t('login.rules.code.pattern'), trigger: 'submit' }
        ]
      },
      errors: false,
      errorInfo: ''
    }
  },

  methods: {
    ...mapGetters([
      'getUsername',
      'getPassword'
    ]),
    ...mapActions([
      'twoFactorAuth',
      'parseUserAuthorities',
      'localprojectAction',
      'loadLogoMenuAction',
      'chargeUrlIn'
    ]),

    getImgUrl () {
      if (this.logo !== null) {
        return require('../../assets/images/login/' + this.logo)
      } else {
        return ''
      }
    },

    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('login.logging')
          })
          try {
            const data = {
              username: this.getUsername(),
              password: this.getPassword(),
              responseCaptcha: null,
              css: this.css,
              urlIn: this.localproject,
              token2fa: this.twoFactorAuthForm.code
            }

            await this.twoFactorAuth(data)
            this.parseUserAuthorities()

            router.push({
              name: 'b2b-app',
              params: {
                password: this.getPassword(),
                username: this.getUsername()
              }
            })
          } catch (error) {
            console.log('LOGIN CATCH: ', error)
            let errorSms = ''
            let statusCode = null
            if (error !== undefined) {
              statusCode = error.status
            }
            switch (statusCode) {
              case 400:
                errorSms = this.$t('error.e400')
                break
              case 401:
                errorSms = this.$t('error.e401_two_factor_auth')
                break
              case 500:
                errorSms = this.$t('error.e500')
                break
              default:
                errorSms = 'Error de conexión con el servidor'
                break
            }
            this.$notify({
              title: errorSms,
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 10000
            })
            this.errors = true
            this.errorInfo = errorSms
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!')
          this.errors = true
          return false
        }
      })
    }
  },

  async created () {
    // Ponemos los estilos
    await this.loadLogoMenuAction(this.logomenu)
    await this.localprojectAction(this.localproject)
    await this.chargeUrlIn(this.localproject)
  }
}

</script>

<style lang="scss" scoped>
.twoFactorAuth-form {
  width: 100%;
  padding-top: $space-200;

  @include mediaXs {
    max-width: rem(300);
    padding-top: $space-700;
    min-width: rem(230);
  }

  /* login title & description */

  &__title {
    text-align: center;
    font-size: 20px;
    font-weight: 300;
    margin: 34px 0;
  }
  &__cau {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #8a0072;
  }
  &__canalcau {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #0084c9;
  }
  h1.woFactorAuth-form__cau.margincau {
    margin-top: 5%;
  }
  &__description {
    @include txt-body-300;
    padding-bottom: $space-500;
    color: var(--color-txt-secondary);
  }

  /* label password */

  &__label-pass {
    display: flex;
    justify-content: space-between;
    padding-bottom: $space-050;

    @include txt-body-200;
    color: var(--color-txt-secondary);
  }

  /* Actions */

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: $space-200;
    .btnRcovery {
      padding-left: inherit;
      margin-left: auto;
      background-color: transparent;
    }
  }

  /* Errors */

  &__errors {
    margin-bottom: $space-300;
  }

  /* Register */

  &__register {
    display: flex;
    justify-content: space-between;
    margin-top: $space-400;
    padding-top: $space-400;

    border-top: $border-size-200 dotted var(--color-border-hard-divisor);
    @include txt-body-400;
    text-align: center;

    & > a {
      color: var(--color-txt-interactive);
      margin-left: $space-200;
      transition: 0.3s all ease;

      &:hover {
        color: var(--color-bg-hover);
      }
    }
  }
}
</style>
